export const FetchURL = "https://dummyjson.com/products"